var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "key-attributes-wrap" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.formData },
        on: {
          Refresh: _vm.Refresh,
          search: _vm.onHandleSearch,
          selectChange: _vm.SecondChange,
        },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "warning", icon: "el-icon-upload2" },
                    on: { click: _vm.onHandleExport },
                  },
                  [_vm._v("导出")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "info" }, on: { click: _vm.addData } },
                  [_vm._v("新增")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "section",
        { staticClass: "content-wrap" },
        [
          _c("table-list", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingData,
                expression: "loadingData",
              },
            ],
            ref: "table",
            attrs: { tableData: _vm.tableData },
            on: {
              "submit-form": _vm.submitForm,
              onHandleEdit: _vm.onHandleEdit,
            },
          }),
        ],
        1
      ),
      _c("add-attribute", {
        ref: "addAttributeRef",
        attrs: { cidType: _vm.cidType },
        on: { "on-change": _vm.submitForm },
      }),
      _c("edit-config-dialog", {
        ref: "editConfig",
        on: { "submit-form": _vm.submitForm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }